package org.hs_soft.runmynesto.pages.login.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.percent

@Composable
fun SignIn(
    email: String,
    password: String,
    info: String,
    loading: Boolean,
    onEmailChange: (String) -> Unit,
    onPasswordChange: (String) -> Unit,
    onSubmitClick: () -> Unit,
    onForgottenPasswordClick:()->Unit,
)
{
    val passwordVisibility= remember { mutableStateOf(false) }
    Column(
        modifier = Modifier
            .fillMaxHeight()
            .fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        SpanText(
            text =info ,
            modifier = Modifier
                .margin(top= Dimen.largePadding)
                .color(Theme.TextSecondary.rgb)
                .textAlign(TextAlign.Center)
                .fontFamily(FontFamily.Jakarta)
                .fontWeight(FontWeight.Normal)
                .fontSize(FontSizes.mediumFontSize)
                .lineHeight(100.percent)
        )

        Spacer()

        CustomEditText(
            modifier = Modifier,
            label = Strings.current().email,
            value = email,
            isRequired = false,
            hint = Strings.current().enterYourEmail,
            onFocusIn = {},
            onFocusOut = {},
            onInputChange = {it, validation ->
                onEmailChange(it)
            },
        )

        CustomEditText(
            modifier = Modifier,
            label = Strings.current().password,
            value = password,
            inputType =if (passwordVisibility.value) InputType.Text
                    else InputType.Password,
            endIconPath = if (passwordVisibility.value)
                Res.PathIcon.hideEye else Res.PathIcon.showEye,
            isRequired = false,
            hint = Strings.current().enterYourPassword,
            onFocusIn = {},
            onFocusOut = {},
            onEndIconClick = {
                passwordVisibility.value=!passwordVisibility.value
            },
            onInputChange = {it, validation ->
                onPasswordChange(it)
            },
        )



        LoginSubmitButton(
            tvTitle = Strings.current().forgetYourPassword,
            buttonTitle= Strings.current().signIn,
            loading=loading,
            isClickable = email.isNotEmpty() && password.isNotEmpty(),
            onButtonClick={
                onSubmitClick()
            },
            onTitleClick={
                onForgottenPasswordClick()
            }
        )



    }




}